import { render, staticRenderFns } from "./core-teammate-groups.html?vue&type=template&id=2fe7b2eb&scoped=true&external"
import script from "./core-teammate-groups.js?vue&type=script&lang=js&external"
export * from "./core-teammate-groups.js?vue&type=script&lang=js&external"
import style0 from "./core-teammate-groups.scss?vue&type=style&index=0&id=2fe7b2eb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe7b2eb",
  null
  
)

export default component.exports